/**
 * Generate or retrieve a unique device ID for the browser
 * This ID is stored in localStorage and persists across sessions
 * @returns {string} A unique device identifier
 */
export const getOrCreateDeviceId = (): string => {
  const STORAGE_KEY = 'device_id';
  
  // Try to get existing device ID from localStorage
  let deviceId = localStorage.getItem(STORAGE_KEY);
  
  // If no device ID exists, generate a new one
  if (!deviceId) {
    // Generate a UUID-like identifier
    deviceId = 'dev_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem(STORAGE_KEY, deviceId);
  }
  
  return deviceId;
};

/**
 * Clear the device ID (useful for logout or reset)
 */
export const clearDeviceId = (): void => {
  localStorage.removeItem('device_id');
};

